export interface ResolveActiveAccountIdInput {
  accountIds: number[];
  /**
   * The ids of the read-only demo artist (LaziiBee). An explicit pick of the demo (URL, current
   * selection, stored id) is kept, but the fallback never picks it.
   */
  demoAccountIds?: number[];
  /** `?accountId=` from the URL. The native embeds (Promote, Catalog) send it. */
  queryId: number | null;
  currentId: number | null;
  storedId: number | null;
}

/**
 * The artist the app should show.
 *
 * Order: the URL, then the current selection, then the id stored for this user, then the
 * workspace's first artist that is not the demo (design: music24-demo-artist a1). Only an artist
 * of this workspace qualifies. After a team join or leave, an id from the old workspace is dropped
 * and the resolver falls through. A list that holds only the demo gives null: the user sees the
 * "no artist" state, and picks LaziiBee in the switcher if they want the example.
 */
export function resolveActiveAccountId({
  accountIds,
  demoAccountIds = [],
  queryId,
  currentId,
  storedId,
}: ResolveActiveAccountIdInput): number | null {
  if (accountIds.length === 0) {
    return null;
  }
  for (const candidate of [queryId, currentId, storedId]) {
    if (candidate !== null && accountIds.includes(candidate)) {
      return candidate;
    }
  }
  return accountIds.find((id) => !demoAccountIds.includes(id)) ?? null;
}
